import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $isTableCellNode } from '@lexical/table';
import { mergeRegister } from '@lexical/utils';
import {
  $findMatchingParent,
  $getSelection,
  $isElementNode,
  $isRangeSelection,
  COMMAND_PRIORITY_HIGH,
  INSERT_PARAGRAPH_COMMAND,
} from 'lexical';

const InsertParagraphPlugin = () => {
  const [editor] = useLexicalComposerContext();

  /**
   * Controls how we insert paragraphs within table cells, to avoid having paragraphs with 0px font-size since templates
   * from the BE always comes with this set in the table cells. In this case, we try to insert a line-break (<br>)
   * instead of full paragraph (<p>) to avoid having it inserted outside the table cell child.
   */
  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        INSERT_PARAGRAPH_COMMAND,
        () => {
          const selection = $getSelection();

          if (!$isRangeSelection(selection)) {
            return false;
          }

          const anchorNode = selection.anchor.getNode();
          const tableCell = $findMatchingParent(anchorNode, $isTableCellNode);

          if (tableCell) {
            // Find the immediate child of the table cell that contains our text
            let currentNode = anchorNode;
            let parentOfCurrent = currentNode.getParent();

            // Traverse up until we find the node whose parent is the table cell
            while (parentOfCurrent && !$isTableCellNode(parentOfCurrent)) {
              currentNode = parentOfCurrent;
              parentOfCurrent = currentNode.getParent();
            }

            // Now currentNode is the div (direct child of table cell)
            if (
              currentNode &&
              $isElementNode(currentNode) &&
              $isTableCellNode(parentOfCurrent)
            ) {
              // Inserts a line break instead of a full paragraph so it remains with the parent node styling
              selection.insertLineBreak();

              return true;
            }
          }

          return false;
        },
        COMMAND_PRIORITY_HIGH,
      ),
    );
  }, [editor]);

  return null;
};

export default InsertParagraphPlugin;
